/**
 * @name AlertSnackBar
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Este componente é um Snackbar que exibe um alerta com uma mensagem e um botão de fechar.
 * O componente deve estar posicionado no dentro do grid pai para exibir o alerta na página desejada.
 * @param {boolean} open - Se o alerta está aberto.
 * @param {string} message - A mensagem do alerta.
 * @param {"success" | "error" | "info"} severity - A severidade do alerta.
 * @param {() => void} onClose - Função para fechar o alerta.
 * @returns {JSX.Element} - O JSX do componente.
 * @package src/components/utils/AlertSnackBar.tsx
 **/

import { Alert, Snackbar } from '@mui/material'
import React from 'react'
import { useAlertContext } from './useAlertContext'

export const AlertSnackbar: React.FC = () => {
  const { alert, setAlert } = useAlertContext()

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    setAlert(prev => ({
      ...prev,
      open: false,
    }))
  }

  return (
    <Snackbar
      open={alert.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={alert.severity}
        variant='filled'
        sx={{
          width: '100%',
          minWidth: '300px',
          maxWidth: '600px',
        }}
      >
        {alert.message}
      </Alert>
    </Snackbar>
  )
}
